import { isEmpty } from 'lodash';
import { createAPIService } from './api.service';

export const MAIN_ENDPOINT = '/user/api/v2/admin/permissions';

const service = createAPIService(MAIN_ENDPOINT);

service.getPermissions = async params =>
  (await service.get('', { params: params })).data;

service.getPermission = async id => (await service.get(`/${id}`)).data;

service.createPermission = async permission => {
  let name = `${permission.systemType}:${permission.value}:${permission.action}`;
  if (!isEmpty(permission.options)) {
    name = `${name}:${permission.options}`;
  }
  return (
    await service.post('', {
      ...permission,
      type: 'SYSTEM',
      name: name,
    })
  ).data;
};

service.updatePermission = async (id, permission) => {
  let name = `${permission.systemType}:${permission.value}:${permission.action}`;
  if (!isEmpty(permission.options)) {
    name = `${name}:${permission.options}`;
  }
  return (
    await service.patch(`/${id}`, {
      ...permission,
      type: 'SYSTEM',
      name: name,
    })
  ).data;
};

service.deletePermission = async id => (await service.delete(`/${id}`)).data;

export default service;
